import React from 'react';
import type { EmailQuestion as EmailQuestionType } from './survey.types';
import { useLanguageStore } from '../../stores/languageStore';
import LanguageHelper from '../../utils/languageHelper';

interface EmailQuestionProps {
  question: EmailQuestionType;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  displayNumber?: number;
}

export const EmailQuestion: React.FC<EmailQuestionProps> = ({
  question,
  value,
  onChange,
  error,
  displayNumber,
}) => {
  const languageCode = useLanguageStore((state) => state.code);

  return (
    <div className="survey-question single-line-text-question">
      <label className="question-label">
        {displayNumber != null && (
          <span className="question-number">{displayNumber}.</span>
        )}
        <span dangerouslySetInnerHTML={{ __html: question.question_text[languageCode] }} />
        {question.is_required && <span className="required-indicator">*</span>}
      </label>
      <input
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-input"
        placeholder={LanguageHelper.getExtendedTranslation(languageCode, 'enterYourEmail')}
        inputMode="email"
        autoComplete="email"
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};
